import LoginForm from "../app/auth/LoginForm";
import Flex from "../core/components/Flex";
import { Card, Typography } from 'antd';
import {useTranslation} from "react-i18next";
import {isMobile} from "react-device-detect";

export default function LoginPage()
{
    const {t} = useTranslation();

    return (
        <Flex
            flexDirection={'column'}
            justifyContent={'start'}
            alignItems={'center'}
            style={{
                minHeight: '100vh',
                backgroundColor: '#edf2f8',
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${window?.AppSettings?.theme?.background?.path})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: isMobile ? '16px' : '0',
            }}
        >
            <img 
                src={window.AppSettings.theme.logo.path} 
                style={{
                    width: isMobile ? '80%' : 300,
                    maxWidth: 300,
                    marginTop: isMobile ? 32 : 64, 
                    marginBottom: isMobile ? 32 : 64
                }}
                alt="Logo"
            />
            <Card
                title={t('Login')}
                style={{
                    width: isMobile ? '100%' : 500,
                    maxWidth: 500,
                }}
                styles={{
                    body: { padding: isMobile ? 16 : 24 }
                }}
            >
                <LoginForm />
            </Card>
        </Flex>
    )
}
